import { TTableRef } from '@/components/Table4/helpers/types';
import { TableState } from '@tanstack/react-table';
import { dequal } from 'dequal/lite';
import { useEffect, useState } from 'react';

export default function useGetTableStateFromRef<T>(tableRef: TTableRef<T>): Partial<TableState> {
  const [state, setState] = useState<Partial<TableState>>({});

  useEffect(() => {
    const _state = tableRef.current?.getState();

    setState((prev) => {
      if (_state && !dequal(_state, prev)) return _state;
      return prev;
    });
  }, [tableRef]);

  return state;
}
